export const GEN_AI_BASICS = [5665236, 6499149, 6186521, 6610777, 6102385, 2862014];

export const GOOGLE_AI = [
    6132321, 6621179, 6023522, 6687771, 6855005, 6902857, 6904047, 6845431, 6610777,
];

export const MS_COPILOT = [5918220, 6526237, 6149533, 6824701, 6298761, 6894799, 6082323];

export const CLAUDE_CODE = [6685939, 5868968, 6528507, 6841539, 6868411];

export const AI_DATA_UTILIZATION = [
    2862014, 5918220, 6132321, 6487883, 6518569, 6626805, 5710978, 6770985,
];

export const GEN_AI_BUSINESS_EFFICIENCY_IMPROVEMENT = [
    4097006, 6002000, 6904047, 6464257, 6571649, 6629171, 7022629,
];
export const MANAGEMENT = [2845708, 4185226, 6801901, 3359158, 5819504, 6469595, 6613721, 6216077];
export const PRESENTATION_AND_WORK = [
    3834644, 3669866, 6556485, 6286469, 3741326, 6648313, 6765857, 6839863, 6608967, 3317968,
    4545230,
];
export const BUSINESS_FUNDAMENTAL = [
    685762, 2856692, 6626591, 6902857, 975576, 6853871, 5917648, 6853871,
];
export const LEADERSHIP_MANAGEMENT = [
    2845708, 3703214, 2716886, 4790320, 5549202, 3900996, 5377224, 6135033, 6150881,
];
export const PROJECT_MANAGEMENT = [2641420, 6099059, 5224818, 4061604, 4970758, 6751657, 6755489];
export const COMMUNICATION = [
    4790314, 3990208, 4942438, 4942734, 4943034, 5992094, 5886134, 6323843, 3181272, 6153623,
    5313168, 6765857, 6848581, 4709272, 4618364, 6519689,
];
export const PRESENTATION_AND_MEETING_FACILITATION = [
    1685648, 2959396, 2667490, 5639740, 1753920, 4545230, 6507129, 6153595,
];
export const SALE_AND_CUSTOMER_SERVICE = [
    3548258, 5235946, 5977800, 5966472, 6227471, 6483043, 5401316,
];
export const AI_UTILIZATION_DX_PROMOTION = [
    2862014, 6855005, 6023522, 6487883, 6487887, 6443293, 6711549, 4881322, 6683949, 6505371,
];
export const GEN_AI_BUSINESS = [
    6744637, 6645921, 5710978, 5394784, 5297006, 6018306, 6670061, 6747369, 6769555, 6227471,
];

export const GEN_AI_DEVELOPMENT = [6418469, 6745517, 6657987, 7028649, 7036025, 7029201, 6645921];

export const AWS_COURSES = [
    2530502, 2170164, 6537177, 5262546, 6044906, 6411575, 5364250, 5340132, 5756830, 6221333,
    2789348, 2533568, 2771884, 6125705,
];

export const AZURE_COURSES = [
    3806930, 5470120, 5689016, 6658599, 5136022, 4319484, 4623900, 4389006, 5533000, 5071956,
    5944174, 3492150, 2782102, 4285156,
];
export const GOOGLE_COURSES = [5157212, 6779793, 5024218, 4738316, 4473754, 5145506];
export const NATIONAL_COURSES = [
    4851392, 3741090, 2070951, 6283107, 6011966, 6279883, 4550438, 3809548, 5082254, 5493804,
    5964982,
];
export const VENDOR_COURSES = [
    6358511, 6479501, 6931459, 3675438, 5881400, 4693822, 3130480, 2723938, 4605474, 4942658,
    5503782,
];
export const OTHER_QUALIFICATIONS = [
    6648289, 6592507, 6433913, 6102385, 4381412, 4189212, 4447540, 4899834, 4997464, 5428994,
];
